import Vue from 'vue';
import Campaign from '@/models/Campaign';
import { getRequest } from '@/api';
import { CAMPAIGN_MUTATIONS } from '@/store/mutation-types';
const ALL_SC_GROUPS = 'all';
export const state = () => ({
  personalCampaigns: {},
  personalCampaignTemplates: {},
  campaigns: [],
  messages: [],
  campaignsPending: false,
  campaignsError: null,
  serviceClassGroup: null,
});

export const actions = {
  fetchCampaigns({ commit, rootGetters }) {
    commit('setServiceClassGroup', rootGetters['user/user'].serviceClassGroup);
    getRequest(
      '',
      CAMPAIGN_MUTATIONS,
      commit,
      process.env.VUE_APP_CAMPAIGNS_URL
    );
  },
  addCampaignMessage({ commit }, campaignMessage) {
    commit('addCampaignMessage', campaignMessage);
  },
  clear({ commit }) {
    commit('clear');
  },
};

export const mutations = {
  [CAMPAIGN_MUTATIONS.SUCCESS]: (state, data) => {
    const campaignsData = data.campaigns || [];
    const messageData = data.messages || [];
    const campaigns = parseMessages(campaignsData, state);
    const messages = parseMessages(messageData, state);
    Vue.set(
      state,
      'personalCampaignTemplates',
      data.personalOfferTemplates || []
    );
    Vue.set(state, 'campaigns', campaigns);
    Vue.set(state, 'messages', messages);
  },
  [CAMPAIGN_MUTATIONS.PENDING]: (state, pending) =>
    (state.campaignsPending = pending),
  [CAMPAIGN_MUTATIONS.FAILURE]: (state, error) =>
    (state.campaignsError = error),
  setServiceClassGroup: (state, scGroup) => (state.serviceClassGroup = scGroup),
  addCampaignMessage: (state, campaignMessage) => {
    state.personalCampaigns[campaignMessage] = true;
  },
  clear: state => {
    state.personalCampaigns = {};
    state.personalCampaignTemplates = {};
    state.campaigns = [];
    state.messages = [];
  },
};

export const getters = {
  messages: state => state.messages,
  campaigns: state => {
    const personalCampaigns = [];
    for (const personalCampaign in state.personalCampaigns) {
      const campaignTemplate =
        state.personalCampaignTemplates[personalCampaign];
      if (campaignTemplate != null) {
        personalCampaigns.push(new Campaign(campaignTemplate));
      }
    }
    return [...personalCampaigns, ...state.campaigns];
  },
};

function parseMessages(campaignsData, state) {
  const campaigns = [];
  for (const campaignData of campaignsData) {
    const campaign = new Campaign(campaignData);
    if (
      (campaign.serviceClassGroup !== ALL_SC_GROUPS &&
        campaign.serviceClassGroup !== state.serviceClassGroup) ||
      !campaign.ongoing
    ) {
      continue;
    }
    campaigns.push(campaign);
  }
  return campaigns;
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
